"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AiQueryRequest () {
        return AiQueryRequest;
    },
    get AiQueryRequestUrlParams () {
        return AiQueryRequestUrlParams;
    },
    get AskAgentType () {
        return AskAgentType;
    },
    get AskMessage () {
        return AskMessage;
    },
    get AskRequest () {
        return AskRequest;
    },
    get DocumentAgentRequest () {
        return DocumentAgentRequest;
    },
    get EngagementAnalysis () {
        return EngagementAnalysis;
    },
    get EngagementCohortAnalysis () {
        return EngagementCohortAnalysis;
    },
    get EngagementCohortFactorsData () {
        return EngagementCohortFactorsData;
    },
    get EngagementCompanyFactorsData () {
        return EngagementCompanyFactorsData;
    },
    get FormQuestionType () {
        return FormQuestionType;
    },
    get GeneralAgentRequest () {
        return GeneralAgentRequest;
    },
    get GetSavedAIMetaDataResponse () {
        return GetSavedAIMetaDataResponse;
    },
    get GetSavedAIMetaDataUrlParams () {
        return GetSavedAIMetaDataUrlParams;
    },
    get GoalAgentRequest () {
        return GoalAgentRequest;
    },
    get MeetingWorkspaceInsight () {
        return MeetingWorkspaceInsight;
    },
    get PatchCompanyAISettingsRequest () {
        return PatchCompanyAISettingsRequest;
    },
    get PostCompanyAISettingsRequest () {
        return PostCompanyAISettingsRequest;
    },
    get PostEmbeddingsRequest () {
        return PostEmbeddingsRequest;
    },
    get PreMeetingPrep () {
        return PreMeetingPrep;
    },
    get QueueAIReviewCycleRequest () {
        return QueueAIReviewCycleRequest;
    },
    get RephraseFormQuestion () {
        return RephraseFormQuestion;
    },
    get RephraseQuestionType () {
        return RephraseQuestionType;
    },
    get RephraseReviewAnswer () {
        return RephraseReviewAnswer;
    },
    get SummarizeReview () {
        return SummarizeReview;
    },
    get SummarizeReviewCycle () {
        return SummarizeReviewCycle;
    },
    get SurveyAnalysis () {
        return SurveyAnalysis;
    },
    get SurveyInsight () {
        return SurveyInsight;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _response = require("./response");
const PostEmbeddingsRequest = _zod.z.object({
    context: _zod.z.string()
});
const PostCompanyAISettingsRequest = _models.AiSettingsSchema;
const PatchCompanyAISettingsRequest = _models.AiSettingsSchema.partial();
const sharedProps = _zod.z.object({
    findAdditionalContext: _zod.z.boolean().optional().default(false),
    context: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional()
});
const RephraseQuestionType = _zod.z.union([
    _zod.z.literal("text"),
    _zod.z.literal("multiline"),
    _zod.z.literal("goal")
]);
const FormQuestionType = _zod.z.enum([
    "Long answer",
    "Multi-line answer",
    "Numeric",
    "Date",
    "Multiple choice",
    "Instructions",
    "Rating scale",
    "Goal discussion",
    "Goal creation",
    "Numeric calculation"
]);
const RephraseFormQuestion = sharedProps.extend({
    input: _zod.z.string(),
    questionType: FormQuestionType,
    previousResponses: _zod.z.array(_zod.z.string()).optional().default([])
});
const RephraseReviewAnswer = sharedProps.extend({
    answer: _zod.z.array(_zod.z.string()),
    author: _zod.z.string().default(""),
    question: _zod.z.string(),
    subject: _zod.z.string().default(""),
    subText: _zod.z.string().default(""),
    goalName: _zod.z.string().default(""),
    questionType: RephraseQuestionType
});
const SummarizeReview = sharedProps.extend({
    reviewId: _utilsisomorphic.transformObjectId
});
const EngagementAnalysis = sharedProps.extend({
    questionId: _zod.z.string(),
    startDate: _zod.z.string().optional(),
    endDate: _zod.z.string().optional(),
    cohortId: _zod.z.string().nullable().optional()
});
const SummarizeReviewCycle = sharedProps.extend({
    reviewCycleId: _zod.z.string()
});
const MeetingWorkspaceInsight = sharedProps.extend({
    workspaceId: _utilsisomorphic.transformObjectId,
    filters: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional()
});
const PreMeetingPrep = sharedProps.extend({
    meetingId: _utilsisomorphic.transformObjectId,
    workspaceId: _utilsisomorphic.transformObjectId
});
const AskMessage = _zod.z.object({
    role: _zod.z.enum([
        "user",
        "assistant"
    ]),
    content: _zod.z.string()
});
const AskAgentType = _zod.z.enum([
    "document",
    "general",
    "goal"
]);
// Base request fields shared by all agents
const AskRequestBase = _zod.z.object({
    query: _zod.z.string().min(1).max(2000),
    messages: _zod.z.array(AskMessage).optional().default([]),
    sessionId: _zod.z.string().optional()
});
// Document agent options - shared between explicit and default requests
const DocumentAgentFilters = _zod.z.object({
    tags: _zod.z.array(_zod.z.string()).optional()
}).optional();
const DocumentAgentOptions = _zod.z.object({
    limit: _zod.z.number().min(1).max(20).optional().default(10),
    minScore: _zod.z.number().min(0).max(1).optional().default(0.5),
    useQueryExpansion: _zod.z.boolean().optional().default(true),
    useReranking: _zod.z.boolean().optional().default(true)
}).optional();
const DocumentAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("document"),
    filters: DocumentAgentFilters,
    options: DocumentAgentOptions
});
const GeneralAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("general")
});
const GoalAgentRequest = AskRequestBase.extend({
    agent: _zod.z.literal("goal")
});
// Default request - when no agent is specified, classification determines routing
const DefaultAgentRequest = AskRequestBase.extend({
    agent: _zod.z.undefined(),
    filters: DocumentAgentFilters,
    options: DocumentAgentOptions
});
const AskRequest = _zod.z.union([
    DocumentAgentRequest,
    GeneralAgentRequest,
    GoalAgentRequest,
    DefaultAgentRequest
]);
const EngagementCohortFactorsData = _zod.z.object({
    _id: _zod.z.string().nullable(),
    name: _zod.z.string().nullable(),
    description: _zod.z.string().nullable(),
    satisfaction: _zod.z.number(),
    enps: _zod.z.number(),
    factorsLowestToHighest: _zod.z.array(_zod.z.object({
        factor: _zod.z.string().nullable(),
        average: _zod.z.number().nullable()
    }))
});
const EngagementCompanyFactorsData = _zod.z.object({
    enps: _zod.z.number(),
    satisfaction: _zod.z.number(),
    factors: _zod.z.array(_zod.z.object({
        factor: _zod.z.string(),
        average: _zod.z.number().nullable()
    }))
});
const EngagementCohortAnalysis = sharedProps.extend({
    dateRange: _zod.z.string(),
    companyFactorsData: EngagementCompanyFactorsData,
    cohortFactorsData: EngagementCohortFactorsData
});
const SurveyInsight = sharedProps.extend({
    surveyId: _zod.z.string()
});
const SurveyAnalysis = sharedProps.extend({
    surveyId: _utilsisomorphic.transformObjectId
});
const AiQueryRequest = _zod.z.discriminatedUnion("type", [
    SummarizeReview.extend({
        type: _zod.z.literal("review-insight")
    }),
    SummarizeReview.extend({
        type: _zod.z.literal("review-insight-haiku")
    }),
    RephraseReviewAnswer.extend({
        type: _zod.z.literal("review-authoring-haiku")
    }),
    RephraseReviewAnswer.extend({
        type: _zod.z.literal("review-authoring-sonnet")
    }),
    RephraseFormQuestion.extend({
        type: _zod.z.literal("form-question-rephrase")
    }),
    EngagementAnalysis.extend({
        type: _zod.z.literal("engagement-insight")
    }),
    SummarizeReviewCycle.extend({
        type: _zod.z.literal("review-cycle-insight")
    }),
    SummarizeReviewCycle.extend({
        type: _zod.z.literal("review-cycle-insight-haiku")
    }),
    EngagementCohortAnalysis.extend({
        type: _zod.z.literal("engagement-cohort-insights")
    }),
    SurveyInsight.extend({
        type: _zod.z.literal("survey-insight")
    }),
    MeetingWorkspaceInsight.extend({
        type: _zod.z.literal("meeting-workspace-insight")
    }),
    PreMeetingPrep.extend({
        type: _zod.z.literal("pre-meeting-prep")
    })
]);
const AiQueryRequestUrlParams = _zod.z.object({
    retry: _zod.z.string().default("false"),
    responseStyle: _models.LlmResponseStyle
});
const GetSavedAIMetaDataUrlParams = _zod.z.object({
    promptKey: _zod.z.string(),
    promptValue: _zod.z.string(),
    recreate: _zod.z.string().default("false")
});
const GetSavedAIMetaDataResponse = _zod.z.object({
    userId: _zod.z.instanceof(_bson.ObjectId).or(_zod.z.undefined()),
    createdAt: _zod.z.date().or(_zod.z.undefined()),
    completed: _zod.z.boolean().default(false)
});
const QueueAIReviewCycleRequest = _zod.z.object({
    createdBy: _zod.z.string(),
    summary_one: _response.ReviewCycleInsightResponseStream.or(_response.ReviewInsightResponseStream.extend({
        subject: _zod.z.object({
            _id: _zod.z.string(),
            name: _zod.z.string()
        }).optional()
    })),
    summary_two: _response.ReviewCycleInsightResponseStream.or(_response.ReviewInsightResponseStream.extend({
        subject: _zod.z.object({
            _id: _zod.z.string(),
            name: _zod.z.string()
        }).optional()
    })),
    reviewCycleId: _zod.z.string(),
    reviewCycleName: _zod.z.string(),
    reviewCycleStartDate: _zod.z.string().or(_zod.z.date()),
    reviewCycleTemplate: _zod.z.string(),
    reviewCycleGroupName: _zod.z.string().nullish(),
    reviewCycleTotal: _zod.z.number()
});
